/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import FrontLayout from './layouts/FrontLayout';
import WebLayout from './layouts/WebLayout';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import PresentationView from './views/Presentation';
import RequireAuth from 'RequireAuth'

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/auth/login" />
  },
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/auth/login" />
  },
  {
    path: '/privacy-policy',
    exact: true,
    component: FrontLayout,
    routes: [
      {
        path: '/privacy-policy',
        exact: true,
        component: RequireAuth(lazy(() => import('views/PrivacyPolicy')))
      }
    ]
  },
  // {
  //   path: '/',
  //   exact: true,
  //   component: () => <Redirect to="/presentation" />
  // },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('views/Login'))
      },
      // {
      //   path: '/auth/register',
      //   exact: true,
      //   component: lazy(() => import('views/Register'))
      // },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  // {
  //   path: '/',
  //   component: WebLayout,
  //   routes: [
  //     {
  //       path: '/auth/login',
  //       exact: true,
  //       component: lazy(() => import('views/Login'))
  //     },
    
  //   ]
  // },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
     
      {
        path: '/banners',
        exact: true,
        component: RequireAuth(lazy(() => import('views/bannerList')))
      },
      {
        path: '/banneredit/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/bannerEdit')))
      },
      {
        path: '/banners-web',
        exact: true,
        component: RequireAuth(lazy(() => import('views/bannerWebList')))
      },
      {
        path: '/bannersweb',
        exact: true,
        component: RequireAuth(lazy(() => import('views/bannerWeb')))
      },
      {
        path: '/bannerwebedit/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/bannerWebEdit')))
      },
      {
        path: '/catagory',
        exact: true,
        component: RequireAuth(lazy(() => import('views/catagoryCreate')))
      },
      {
        path: '/catagories',
        exact: true,
        component: RequireAuth(lazy(() => import('views/catagoryList')))
      },
      {
        path: '/catagoryedit/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/catagoryEdit')))
      },
      {
        path: '/sub-catagory',
        exact: true,
        component: RequireAuth(lazy(() => import('views/SubCatagoryCreate')))
      },
      {
        path: '/sub-catagories',
        exact: true,
        component: RequireAuth(lazy(() => import('views/SubCatagoryList')))
      },
      {
        path: '/sub-catagory-edit/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/SubCatagoryEdit')))
      },
      {
        path: '/banner',
        exact: true,
        component: RequireAuth(lazy(() => import('views/banner')))
      },
      {
        path: '/customers',
        exact: true,
        component: RequireAuth(lazy(() => import('views/CustomerManagementList')))
      },
      {
        path: '/customers/customeredit/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/CustomerEdit')))
      },
      {
        path: '/customers/customercreate',
        exact: true,
        component: RequireAuth(lazy(() => import('views/CustomerCreate')))
      },
      {
        path: '/brands',
        exact: true,
        component: RequireAuth(lazy(() => import('views/BrandList')))
      },
      {
        path: '/brand/brandedit/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/BrandEdit')))
      },
      {
        path: '/brand/brandcreate',
        exact: true,
        component: RequireAuth(lazy(() => import('views/BrandCreate')))
      },
      {
        path: '/contact-requests',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ContactUs')))
      },
      {
        path: '/create-report',
        exact: true,
        component: RequireAuth(lazy(() => import('views/Reports')))
      },
      {
        path: '/cms-pages',
        exact: true,
        component: lazy(() => import('views/cmsList'))
      },
      {
        path: '/cms-pages/cmscreate/:id',
        exact: true,
        component: lazy(() => import('views/CmsCreate'))
      },
      {
        path: '/product/editcatalog/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/EditCatalog')))
      },
      {
        path: '/product/editcatalognew/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/EditCatalogNew')))
      },
      {
        path: '/catalogs',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProductCatalogList')))
      },
      {
        path: '/catalogsnew',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProductCatalogListNew')))
      },
      {
        path: '/product/createnew',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProductCatalogNew')))
      },
      {
        path: '/product/create',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProductCatalog')))
      },
      // {
      //   path: '/calendar',
      //   exact: true,
      //   component: RequireAuth(lazy(() => import('views/Calendar')))
      // },
      {
        path: '/changelog',
        exact: true,
        component: RequireAuth(lazy(() => import('views/Changelog')))
      },
      // {
      //   path: '/chat',
      //   exact: true,
      //   component: lazy(() => import('views/Chat'))
      // },
      // {
      //   path: '/chat/:id',
      //   exact: true,
      //   component: lazy(() => import('views/Chat'))
      // },
      {
        path: '/dashboard',
        exact: true,
        component: RequireAuth(DashboardAnalyticsView)
      },
      // {
      //   path: '/dashboards/default',
      //   exact: true,
      //   component: DashboardDefaultView
      // },
      // {
      //   path: '/invoices/:id',
      //   exact: true,
      //   component: lazy(() => import('views/InvoiceDetails'))
      // },
      // {
      //   path: '/kanban-board',
      //   exact: true,
      //   component: lazy(() => import('views/KanbanBoard'))
      // },
      // {
      //   path: '/mail',
      //   exact: true,
      //   component: lazy(() => import('views/Mail'))
      // },
      // {
      //   path: '/management/customers',
      //   exact: true,
      //   component: lazy(() => import('views/CustomerManagementList'))
      // },
      {
        path: '/management/customers/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/CustomerManagementDetails')))
      },
      {
        path: '/management/customers/:id/:tab',
        exact: true,
        component: RequireAuth(lazy(() => import('views/CustomerManagementDetails')))
      },
      {
        path: '/management/projects',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProjectManagementList')))
      },
      {
        path: '/orders/:tab',
        exact: true,
        component: RequireAuth(lazy(() => import('views/OrderManagementList')))
      },
      {
        path: '/orders',
        exact: true,
        component: RequireAuth(lazy(() => import('views/OrderManagementList')))
      },
      {
        path: '/management/orders/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/OrderManagementDetails')))
      },
      {
        path: '/overview',
        exact: true,
        component: OverviewView
      },
      {
        path: '/presentation',
        exact: true,
        component: PresentationView
      },
      {
        path: '/profile/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/Profile')))
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: RequireAuth(lazy(() => import('views/Profile')))
      },
      {
        path: '/projects/create',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProjectCreate')))
      },
      {
        path: '/projects/:id',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProjectDetails')))
      },
      {
        path: '/projects/:id/:tab',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProjectDetails')))
      },
      {
        path: '/projects',
        exact: true,
        component: RequireAuth(lazy(() => import('views/ProjectList')))
      },
      {
        path: '/settings',
        exact: true,
        component: RequireAuth(lazy(() => import('views/Settings')))
      },
      {
        path: '/settings/:tab',
        exact: true,
        component: RequireAuth(lazy(() => import('views/Settings')))
      },
      {
        path: '/social-feed',
        exact: true,
        component: RequireAuth(lazy(() => import('views/SocialFeed')))
      },
      {
        path: '/getting-started',
        exact: true,
        component: RequireAuth(lazy(() => import('views/GettingStarted')))
      },
      {
        path: '/send_push_notification',
        exact: true,
        component: RequireAuth(lazy(() => import('views/SendPushNotification')))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
